import React, { useState, useEffect } from 'react';

// warn before closing browser tab
function useConfirmOnTabClose({ enabled= false  }) {
  const message = 'There are unsaved changes.';

  useEffect(() => {
    const beforeClose = (e) => {
      if (enabled) {
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    }

    window.addEventListener('beforeunload', beforeClose);

    return () => {
      window.removeEventListener('beforeunload', beforeClose);
    };
  }, [enabled]);

}

export default useConfirmOnTabClose;
